import React, { useEffect, useState } from "react";

import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import Icon from "./Icon";
import { Category } from "../interfaces/intefaces";
import { BrowseIcon, LiveChatIcon, CasinoIcon, PromotionsIcon, LiveCasinoIcon } from "./Icons";
import { useAtom } from "jotai";
import { categoryTypeAtom, showBrowseModalAtom } from "../state/games";
import { useTranslation } from "../hooks/hooks";
import ModalMobileMenu from "./ModalMobileMenu";
import { getExternalLink } from "../helpers/helpers";
import { routes } from "../router/Routes";
import { useLocation } from "react-router-dom";
import { CATEGORYTYPE_LIVECASINO } from "../config/consts";

interface IProps {
    categories: Category[] | null;
    activeCategory: number;
    updateCategory: (category_id: number) => void;
}

const MobileMenu = ({ categories, activeCategory, updateCategory }: IProps) => {
    const location = useLocation();
    const [value, setValue] = useState("");
    const [showModal, setShowBrowseModal] = useAtom(showBrowseModalAtom);
    const [activeCategoryType, setCategoryType] = useAtom(categoryTypeAtom);
    const { _e } = useTranslation();
    const buttonWidth = window.innerWidth / Math.floor(window.innerWidth / 60);
    useEffect(() => {
        console.log(activeCategory);
        if (location.pathname === routes.pages.offers) {
            setValue("promotions");
        } else {
            if (location.pathname === routes.root || location.pathname.startsWith("/games")) {
                if (activeCategoryType === CATEGORYTYPE_LIVECASINO) {
                    setValue("livecasino");
                } else {
                    setValue("casino");
                }
            } else {
                setValue("browse");
            }
        }
    }, [location, activeCategory]);
    return (
        <>
            <Paper
                className="mobile-menu"
                sx={{
                    zIndex: 1301,
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: "#0f1432",
                    padding: 0,
                    boxShadow: "none",
                    borderRadius: 0,
                    overflow: "auto",
                    "@media (min-width:992px)": {
                        display: "none",
                    },
                }}
                elevation={3}
            >
                <BottomNavigation
                    showLabels={true}
                    value={value}
                    sx={{
                        height: "60px",
                        justifyContent: "flex-start",
                        backgroundColor: "transparent",
                        ".MuiBottomNavigationAction-root": {
                            minWidth: `${buttonWidth}px`,
                            padding: "8px",
                            color: "#fff",
                            svg: {
                                width: "20px",
                                height: "20px",
                                marginBottom: "5px",
                            },
                            ".MuiBottomNavigationAction-label": {
                                borderBottom: "2px solid transparent",
                                fontSize: "14px",
                                "&.Mui-selected": {
                                    color: "#fff",
                                    fontSize: "14px",
                                    borderBottom: "2px solid #ff5c01",
                                },
                            },
                            "@media(max-width:480px)": {
                                padding: "2px",
                                ".MuiBottomNavigationAction-label": {
                                    fontSize: "11px",
                                    "&.Mui-selected": {
                                        fontSize: "11px",
                                    },
                                },

                                svg: {
                                    width: "18px",
                                    height: "18px",
                                },
                            },
                        },
                    }}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                        let u = "";
                        switch (newValue) {
                            case "browse":
                                setShowBrowseModal(!showModal);
                                break;
                            case "casino":
                                window.location.href = getExternalLink("casino");
                                break;
                            case "livecasino":
                                window.location.href = getExternalLink("livecasino");
                                break;
                            case "promotions":
                                window.location.href = getExternalLink("promotions");
                                break;
                            case "helpcenter":
                                window.location.href = getExternalLink("helpcenter");
                                break;
                        }
                    }}
                >
                    <BottomNavigationAction
                        label={_e("Browse")}
                        icon={<Icon icon={BrowseIcon} />}
                        value={"browse"}
                    ></BottomNavigationAction>
                    <BottomNavigationAction
                        label={_e("Casino")}
                        icon={<Icon icon={CasinoIcon} />}
                        value={"casino"}
                    ></BottomNavigationAction>
                    <BottomNavigationAction
                        label={_e("Live Casino")}
                        icon={<Icon icon={LiveCasinoIcon} />}
                        value={"livecasino"}
                    ></BottomNavigationAction>
                    <BottomNavigationAction
                        label={_e("Promotions")}
                        icon={<Icon icon={PromotionsIcon} />}
                        value={"promotions"}
                    ></BottomNavigationAction>
                    <BottomNavigationAction
                        label={_e("Help Center")}
                        icon={<Icon icon={LiveChatIcon} />}
                        value={"helpcenter"}
                    ></BottomNavigationAction>
                </BottomNavigation>
            </Paper>
            {categories && (
                <ModalMobileMenu
                    setCategoryType={setCategoryType}
                    activeCategory={activeCategory}
                    categories={categories}
                    updateCategory={updateCategory}
                />
            )}
        </>
    );
};
export default MobileMenu;
